
const util = {
  urlParse(_url = '')
 {
  let url_obj = new URL(_url || window.location.href);
  let search_path = url_obj.search;
  let handle_path = decodeURIComponent(search_path.substr(1));

  let handle_path_arr = handle_path.split('&');
  let search_params = {};
  for (let item of handle_path_arr) {
    let r = item.split('=');
    search_params[r[0]] = r[1];
  }
  return {
    protpcol: url_obj.protocol,
    search: url_obj.search,
    host: url_obj.host,
    port: url_obj.port,
    pathname: url_obj.pathname,
    searchParams: search_params
  }
  }
}
export default util
